var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtnRound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_178)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_178)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4_178)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.99 0H-0.0100098V24H23.99V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.99 9L13.99 12L10.99 15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.98999 12C2.98999 13.1819 3.22278 14.3522 3.67507 15.4442C4.12737 16.5361 4.7903 17.5282 5.62603 18.364C6.46176 19.1997 7.45391 19.8626 8.54584 20.3149C9.63777 20.7672 10.8081 21 11.99 21C13.1719 21 14.3422 20.7672 15.4342 20.3149C16.5261 19.8626 17.5182 19.1997 18.354 18.364C19.1897 17.5282 19.8526 16.5361 20.3049 15.4442C20.7572 14.3522 20.99 13.1819 20.99 12C20.99 9.61305 20.0418 7.32387 18.354 5.63604C16.6661 3.94821 14.3769 3 11.99 3C9.60304 3 7.31386 3.94821 5.62603 5.63604C3.9382 7.32387 2.98999 9.61305 2.98999 12Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.0100098)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.0100098)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(-0.0100098)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnRound);
export default __webpack_public_path__ + "static/media/btn-round.c4af52f7884f7fd612e917384ad376d7.svg";
export { ForwardRef as ReactComponent };